
(function () {
  'use strict';
  if (window.DaLucaReviewBadgeCleanupV404) return;
  window.DaLucaReviewBadgeCleanupV404 = true;

  function removeBadgeFrames() {
    document.querySelectorAll('.template-product .jdgm-rev-widg__header iframe').forEach(function (frame) {
      var parent = frame.parentElement;
      frame.remove();

      if (
        parent &&
        !parent.querySelector('.jdgm-histogram, .jdgm-rev-widg__summary, .jdgm-row-stars, .jdgm-rev') &&
        !(window.DaLucaI18n.sourceText(parent) || '').trim()
      ) {
        parent.remove();
      }
    });
  }

  function schedule() {
    removeBadgeFrames();
    [100, 350, 800, 1600, 3000].forEach(function (delay) {
      window.setTimeout(removeBadgeFrames, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });

  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._dlV404);
    observer._dlV404 = window.setTimeout(removeBadgeFrames, 80);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

